import * as React from 'react'

type Handler<E extends Event> = (arg0: E) => unknown
export default class NativeEvents extends React.Component<{
  children: (ref: React.Ref<HTMLButtonElement>) => React.ReactNode
  [eventName: string]: Handler<any>
}> {
  el: Element | undefined
  elRef = (nextEl: HTMLButtonElement | null) => {
    const {el} = this

    if (nextEl === el) {
      return
    }

    const {children, ...handlers} = this.props

    if (el) {
      for (const [name, handler] of Object.entries(handlers)) {
        el.removeEventListener(name, handler)
      }
    }

    if (nextEl) {
      this.el = nextEl

      for (const [name, handler] of Object.entries(handlers)) {
        nextEl.addEventListener(name, handler)
      }
    }
  }

  render(): React.ReactNode {
    return this.props.children(this.elRef)
  }
}
